"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var _Title = _interopRequireDefault(require("../Title/Title"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _actionBar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/action-bar.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _actionBar.default);
/**
 * The **Action Bar** is located at the top of the page and is used for page title
 * and main actions for the page.
 */

var ActionBar = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var actions = _ref.actions,
      actionClassName = _ref.actionClassName,
      actionProps = _ref.actionProps,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      backButtonLabel = _ref.backButtonLabel,
      buttonContainerClassName = _ref.buttonContainerClassName,
      buttonProps = _ref.buttonProps,
      description = _ref.description,
      descriptionProps = _ref.descriptionProps,
      headingLevel = _ref.headingLevel,
      headingStyle = _ref.headingStyle,
      title = _ref.title,
      titleProps = _ref.titleProps,
      onBackClick = _ref.onBackClick,
      props = (0, _objectWithoutProperties2.default)(_ref, ["actions", "actionClassName", "actionProps", "className", "cssNamespace", "backButtonLabel", "buttonContainerClassName", "buttonProps", "description", "descriptionProps", "headingLevel", "headingStyle", "title", "titleProps", "onBackClick"]);
  var actionBarClasses = classnames("".concat(cssNamespace, "-action-bar"), className);
  var actionBarHeaderClasses = classnames("".concat(cssNamespace, "-action-bar__header"), className);
  var actionBarBackClasses = classnames("".concat(cssNamespace, "-action-bar__back"), buttonContainerClassName);
  var actionBarDescriptionClasses = classnames("".concat(cssNamespace, "-action-bar__description"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-action-bar__description--back"), onBackClick));
  var actionBarActionsClasses = classnames("".concat(cssNamespace, "-action-bar__actions"), actionClassName);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    className: actionBarClasses,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    className: actionBarHeaderClasses
  }), typeof onBackClick === 'function' && /*#__PURE__*/_react.default.createElement("div", {
    className: actionBarBackClasses
  }, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
    "aria-label": backButtonLabel
  }, buttonProps, {
    compact: true,
    glyph: "navigation-left-arrow",
    onClick: onBackClick,
    option: "transparent"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-action-bar__title"))
  }, /*#__PURE__*/_react.default.createElement(_Title.default, (0, _extends2.default)({}, titleProps, {
    level: headingLevel,
    levelStyle: headingStyle
  }), title)), actions && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, actionProps, {
    className: actionBarActionsClasses
  }), actions)), description && /*#__PURE__*/_react.default.createElement("p", (0, _extends2.default)({}, descriptionProps, {
    className: actionBarDescriptionClasses
  }), description));
});

ActionBar.displayName = 'ActionBar';
process.env.NODE_ENV !== "production" ? ActionBar.propTypes = {
  /** Localized text for the heading */
  title: _propTypes.default.string.isRequired,

  /** Classnames to spread to the action Button container */
  actionClassName: _propTypes.default.string,

  /** Props to spread to the action Button container */
  actionProps: _propTypes.default.object,

  /** Button components to add to the ActionBar */
  actions: _propTypes.default.node,

  /** Localized string for 'Back' button's aria-label. This is required if the button is enabled and `buttonProps` doesn't have a valid `aria-label` */
  backButtonLabel: (0, _reactRequiredIf.default)(_propTypes.default.string, function (props) {
    var _props$buttonProps$ar;

    return typeof (props === null || props === void 0 ? void 0 : props.onBackClick) === 'function' && (!(props === null || props === void 0 ? void 0 : props.buttonProps) || !((_props$buttonProps$ar = props.buttonProps['aria-label']) === null || _props$buttonProps$ar === void 0 ? void 0 : (0, _trim.default)(_props$buttonProps$ar).call(_props$buttonProps$ar)));
  }),

  /** Classnames to spread to the back Button container */
  buttonContainerClassName: _propTypes.default.string,

  /** Additional props to be spread to the `<button>` element */
  buttonProps: _propTypes.default.object,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Localized text for the description */
  description: _propTypes.default.string,

  /** Additional props to be spread to the description\'s `<p>` element */
  descriptionProps: _propTypes.default.object,

  /** Heading level. `<h1>` is reserved for the page title */
  headingLevel: _CustomPropTypes.default.range(2, 6),

  /** Heading style, if it should be different from the default style for the heading level. */
  headingStyle: _CustomPropTypes.default.range(2, 6),

  /**Additional props to be spread to the title\'s heading element */
  titleProps: _propTypes.default.object,

  /**
   * Callback function; triggered when the back button is clicked.
   * If this is not set to a function, the back button won't be rendered.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
  */
  onBackClick: _propTypes.default.func
} : void 0;
ActionBar.defaultProps = {
  headingLevel: 3
};

var _default = (0, _withStyles.default)(ActionBar);

exports.default = _default;